import {BaseControlCollection} from "./_BaseControlCollection";

export class ControlGroupCollection extends BaseControlCollection<Backbone.Model> {

    url = () => {
        return window.location.origin + '/api/v1/app/' +  this.appUrlRoot + '/control_groups';
    };

    comparator = (model) => {
        return model.get('name');
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/apps/controls/collections/ControlGroups.ts